module.exports = __webpack_public_path__ + "static/media/subscription.1034af53.svg";